// this is an autogenerated file from App/Account/Content/Calendar/New/AppointmentOverlay/Content/Old/mutation-schedule-existing-patient-and-new-appointment.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Calendar_New_AppointmentOverlay_Content_Old(
  $patient_id: uuid!
  $location_id: uuid!
  $appointment_type_id: uuid!
  $chair_id: uuid!
  $treatment_id: uuid!
  $date: date!
  $start_time: time!
  $end_time: time!
  $note: String
  $unplanned: Boolean!
) {
  calendar_scheduling_admin_for_existing_patient_and_new_appointment(
    args: {
      _patient_id: $patient_id
      _location_id: $location_id
      _appointment_type_id: $appointment_type_id
      _chair_id: $chair_id
      _treatment_id: $treatment_id
      _date: $date
      _start_time: $start_time
      _end_time: $end_time
      _note: $note
      _unplanned: $unplanned
    }
  ) {
    _id
    id
  }
}

`